import React, { useState } from 'react';
import { Spinner, Text } from '@chakra-ui/react';
import useServerApi from 'hooks/useServerApi';
import Settings from './Settings';
import GoogleAuthPrompt from './GoogleAuthPrompt';

const GoogleCalendarSettings = ({
    isEnabled,
    isLoggedIn,
    onSettingsRefresh,
    isSaving,
    setCalendarSettings,
    calendarSettings,
    setCalendarSaveLoading,
    toast
}) => {
    const [{ get, post }] = useServerApi();
    const [isLoading] = useState(false);
    const [authUrlLoading, setAuthUrlLoading] = useState(false);
    const [authUrlError, setAuthUrlError] = useState(null);
    const [authUrlData, setAuthUrlData] = useState(null);
    const googleAuthUrlEndpoint = `/rest_endpoints/google_calendar_auth`;
    const googleCalendarSaveUrl = `/rest_endpoints/google_calendar_selection_save`;

    // Handler for saving preferences
    const handleSavePreferences = async (settingsToSave) => {
        setCalendarSaveLoading(true);
        const [, res,] = await post(googleCalendarSaveUrl, {
            calendar_id: settingsToSave.calendar_id,
            calendar_name: settingsToSave.calendar_name,
            is_enabled: isEnabled,
            time_interval: settingsToSave.time_interval,
            custom_variables: settingsToSave.custom_variables || [],
            default_event_duration: settingsToSave.default_event_duration || 30,
            schedule: settingsToSave.schedule,
            start_time_increments: settingsToSave.start_time_increments || { ':15': true, ':30': true, ':00': true },
        });
        const saveSuccess = typeof res?.is_saved !== 'undefined' ? res.is_saved : false;
        if (saveSuccess) {
            await onSettingsRefresh();
            setCalendarSaveLoading(false);
            toast({
                title: 'Settings saved.',
                description: `Calendar: ${settingsToSave.calendar_name}, Interval: ${settingsToSave.time_interval} minutes`,
                status: 'success',
                isClosable: true,
            });
            return;
        }
        setCalendarSaveLoading(false);
        toast({
            title: 'Failed to save settings.',
            description: 'Please try again later.',
            status: 'error',
            isClosable: true,
        });
    };

    // Handler for lifted state
    const onCalendarSettingsChange = (k, v) => {
        setCalendarSettings(prev => ({ ...prev, [k]: v }));
    };

    if (isLoading) {
        return <Spinner size='md' />;
    }
    if (!isEnabled) {
        return <Text color='gray.500'>Enable to connect your Google Calendar.</Text>;
    }
    if (!isLoggedIn) {
        return (
            <GoogleAuthPrompt
                authUrlLoading={authUrlLoading}
                authUrlError={authUrlError}
                authUrlData={authUrlData}
                setAuthUrlLoading={setAuthUrlLoading}
                setAuthUrlError={setAuthUrlError}
                setAuthUrlData={setAuthUrlData}
                get={get}
                googleAuthUrlEndpoint={googleAuthUrlEndpoint}
            />
        );
    }
    return (
        <Settings
            calendarSettings={calendarSettings}
            onCalendarSettingsChange={onCalendarSettingsChange}
            onSave={handleSavePreferences}
            isSaving={isSaving}
        />
    );
};

export default GoogleCalendarSettings;